import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import PageAx                 from 'app/actions/company-admin/page-settings';
import ToastAx                from 'app/actions/toast';
import CurrencyInput          from 'app/components/common/currency-input';
import Meta                   from 'app/components/common/meta';
import SegmentedSelectorInput from 'app/components/common/segmented-selector-input';
import LayoutMatchSettings    from 'app/components/company-admin/match-settings/layout';
import ModalFees              from 'app/components/company-admin/match-settings/modal-fees';
import ModalGracePeriod       from 'app/components/company-admin/match-settings/modal-grace-period';
import ModalTiers             from 'app/components/company-admin/match-settings/modal-match-tiers';
import PageLoading            from 'app/components/layout/page-loading';
import BudgetsDuck            from 'app/ducks/company-admin/budgets';
import format                 from 'app/helpers/format';
import prompts                from 'app/prompts';
import CadminSlx              from 'app/selectors/company-admin/';
import PageSlx                from 'app/selectors/company-admin/page-settings';

class PageCadminSettings extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showModalFees: false,
      budgetInputVal: null,
      showBudgetEdit: false,
      showTiersEdit: false,
      showGracePeriodEdit: false,
    };

    this.refMatchAmount = React.createRef();

    this.onClickEditTiers = this.onClickEditTiers.bind(this);
    this.onCloseTiersModal = this.onCloseTiersModal.bind(this);
    this.onClickEditBudget = this.onClickEditBudget.bind(this);
    this.onClickCancelBudget = this.onClickCancelBudget.bind(this);
    this.onClickSaveBudget = this.onClickSaveBudget.bind(this);
    this.onChangeBudgetAmount = this.onChangeBudgetAmount.bind(this);
    this.onClickFees = this.onClickFees.bind(this);
    this.onCloseFees = this.onCloseFees.bind(this);
    this.onClickGracePeriod = this.onClickGracePeriod.bind(this);
    this.onCloseGracePeriod = this.onCloseGracePeriod.bind(this);
    this.onChangeAutomaticMatches = this.onChangeAutomaticMatches.bind(this);
    this.onChangeSearchApprovedNonprofitsOnly = this.onChangeSearchApprovedNonprofitsOnly.bind(this);
  }

  get hasTiers() {
    return !!this.props.budget?.tiers?.length;
  }

  onClickFees() {
    this.setState({showModalFees: true});
  }
  onCloseFees() {
    this.setState({showModalFees: false});
  }

  onClickGracePeriod() {
    this.setState({showGracePeriodEdit: true});
  }
  onCloseGracePeriod() {
    this.setState({showGracePeriodEdit: false});
  }

  onChangeAutomaticMatches(option) {
    const automaticMatches = option.value === 'on';
    this.props.saveAutomaticMatches(automaticMatches);
  }

  onChangeSearchApprovedNonprofitsOnly(option) {
    const searchApprovedNonprofitsOnly = (option.value === 'on');
    this.props.saveSearchApprovedNonprofitsOnly(searchApprovedNonprofitsOnly);
  }

  onClickEditBudget() {
    this.setState({showBudgetEdit: true, budgetInputVal: this.props.budget.allocatedAmount});
  }
  onClickCancelBudget() {
    this.setState({showBudgetEdit: false, budgetInputVal: this.props.budget.allocatedAmount});
  }
  onChangeBudgetAmount({amount: budgetInputVal}) {
    this.setState({budgetInputVal});
  }
  async onClickSaveBudget() {
    const {budgetInputVal} = this.state;
    const msg = `You're about to change the annual Match budget to ${format.usd(budgetInputVal)}`;
    const didConfirm = await prompts.confirm({msg});
    if (didConfirm) {
      await this.props.saveBudget(budgetInputVal);
      this.setState({showBudgetEdit: false});
      this.props.toastSuccess('Annual Match budget updated.');
    }
  }

  onClickEditTiers() {
    this.setState({showTiersEdit: true});
  }
  onCloseTiersModal(didUpdate=false) {
    this.setState({showTiersEdit: false});
    if (didUpdate) {
      this.props.toastSuccess('Employee match settings updated.');
    }
  }

  renderBudget() {
    const {budget, isSavingBudget} = this.props;
    const {showBudgetEdit, budgetInputVal} = this.state;
    if (!budget) return 'loading...';
    const saveBtnDisabled = (() => {
      if (isSavingBudget) return true;
      return false;
    })();
    const amount = (budgetInputVal == null) ? budget.allocatedAmount : budgetInputVal;

    return (
      <div className="ca-match-general-fi">
        <div className="ca-match-general-fi-text">
          <div className="ca-match-general-fi-text-title">Annual Company Budget</div>
        </div>
        <div className="ca-match-general-fi-kvs">
          <div className="ca-match-general-fi-kvs-kv">
            {showBudgetEdit ? (
              <CurrencyInput className="ca-match-general-fi-kvs-input" amount={amount} onChange={this.onChangeBudgetAmount} />
            ) : (
              <div className="ca-match-general-fi-kvs-val">{format.usd(budget.allocatedAmount)}</div>
            )}
            <div className="ca-match-general-fi-kvs-key">Cap for entire company</div>
          </div>
        </div>
        <div className="ca-match-general-fi-ctas">
          {showBudgetEdit ? (<>
            <button className="btn secondary small" key={2} onClick={this.onClickCancelBudget} disabled={isSavingBudget}>Cancel</button>
            <button className="btn blue small" key={3} onClick={this.onClickSaveBudget} disabled={saveBtnDisabled}>{isSavingBudget ? 'Saving...' : 'Save'}</button>
          </>) : (<>
            <button className="btn small blue secondary" key={1} onClick={this.onClickEditBudget}>Edit Budget</button>
          </>)}
        </div>
      </div>
    );
  }

  renderTier(index, {condition, matchPercent, employeeAmount}) {
    let cattr, cattrOpt;
    if (condition) {
      (this.props.cattrSet?.cattrs || []).find((c) => {
        return c.options.find((o) => {
          if (o.id === condition) {
            cattr = c;
            cattrOpt = o;
            return true;
          }
        });
      });
    }

    const [title, title2, title3] = (() => {
      if (condition) {
        return cattrOpt
          ? [cattrOpt.name, cattr.name, `${cattrOpt.employeeCount} ${format.pluralize('Employee', cattrOpt.employeeCount)}`]
          : ['Invalid Group', 'The custom attribute or option has been deleted.'];
      }
      return this.hasTiers
        ? ['All Other Employees']
        : ['All Employees'];
    })();

    return (
      <div key={index} className="ca-match-general-fi alt2">
        <div className="ca-match-general-fi-text">
          <div className="ca-match-general-fi-text-title">{title}</div>
          {!!title2 && <div className="ca-match-general-fi-text-title2">{title2}</div>}
          {!!title3 && <div className="ca-match-general-fi-text-title3">{title3}</div>}
        </div>
        <div className="ca-match-general-fi-kvs">
          <div className="ca-match-general-fi-kvs-kv">
            <div className="ca-match-general-fi-kvs-val">{format.matchRatio(matchPercent)}</div>
            <div className="ca-match-general-fi-kvs-key">Match Ratio</div>
          </div>
          <div className="ca-match-general-fi-kvs-kv">
            <div className="ca-match-general-fi-kvs-val">{format.usd(employeeAmount)}</div>
            <div className="ca-match-general-fi-kvs-key">Cap per employee, per year</div>
          </div>
        </div>
      </div>
    );
  }

  renderEmpAllowances() {
    const {budget} = this.props;
    return (
      <div>
        {budget.tiers.map((t, i) => this.renderTier(i, t))}
        {this.renderTier(-1, _.pick(budget, ['matchPercent', 'employeeAmount']))}
        <button className="btn secondary small blue" onClick={this.onClickEditTiers}>Edit Employee Match Settings</button>
      </div>
    );
  }

  render() {
    const { company, isSavingAutomaticMatches, isSavingSearchApprovedNonprofitsOnly, budget } = this.props;
    const { showModalFees, showTiersEdit, showGracePeriodEdit } = this.state;
    if (!company) return <PageLoading />;
    const isGpOn = !!company.gracePeriodValue;

    return (
      <LayoutMatchSettings tab="general" className="ca-match-general">
        <Meta title="Match Settings | Millie" />

        <div className="ca-box">
          <div className="ca-box-header">
            <h1 className="ca-box-header-title">Annual Company Budget</h1>
          </div>
          <div className="ca-box-body">
            {this.renderBudget()}
          </div>

          <div className="ca-box-header">
            <h1 className="ca-box-header-title">Employee Match Caps & Ratios</h1>
          </div>
          <div className="ca-box-body">
            {this.renderEmpAllowances()}
          </div>
        </div>

        <div className="ca-box">
          <div className="ca-box-header">
            <h1 className="ca-box-header-title">Default Match Rule</h1>
          </div>
          <div className="ca-box-subheader">
            <p style={{maxWidth: 600}}>Any donation to a nonprofit with unspecified approve/restrict settings will be processed based on the criteria you select below. For those unspecified donations, would you like the system to automatically process a match or would you like to manually review donations before matching?</p>
          </div>
          <div className="ca-box-body">
            <SegmentedSelectorInput
              className="automatic-matches"
              options={[{label: 'Automatically Approve', value: 'on'}, {label: 'Manually Approve/Restrict', value: 'off'}]}
              value={company.automaticMatches ? 'on' : 'off'}
              onChange={this.onChangeAutomaticMatches}
              disabled={isSavingAutomaticMatches}
              subtext={isSavingAutomaticMatches ? <span className="faint">saving...</span> : null}
            />
          </div>

          <div className="ca-box-header">
            <h1 className="ca-box-header-title">Donation & Match Fees</h1>
          </div>
          <div className="ca-box-body">
            <div className="ca-match-general-fees-toggle">
              <div className={`ca-match-general-fees-toggle-status ${company.feesCoverMatch ? 'on' : 'off'}`}>{company.feesCoverMatch ? 'On' : 'Off'}</div>
              <div>Cover Match Fees</div>
            </div>
            <div className="ca-match-general-fees-toggle">
              <div className={`ca-match-general-fees-toggle-status ${company.feesCoverDonation ? 'on' : 'off'}`}>{company.feesCoverDonation ? 'On' : 'Off'}</div>
              <div>Cover Employee Donation Fees</div>
            </div>
            <div className="ca-match-general-fees-actions">
              <button className="btn small blue secondary" onClick={this.onClickFees}>Edit Fee Settings</button>
            </div>
          </div>

          <div className="ca-box-header">
            <h1 className="ca-box-header-title">Offline Donation Grace Period</h1>
          </div>
          <div className="ca-box-subheader">
            <p>How long employees have to submit offline donations for match after the year is over</p>
            <p>Offline donations submitted after the grace period will be applied to the current year, even if donation date is in prior year.</p>
          </div>
          <div className="ca-box-body">
            <div className="_flex _justify-start">
              <div className={`ca-match-general-fees-toggle-status ${isGpOn ? 'on' : 'off'}`}>{isGpOn ? 'On' : 'Off'}</div>
              <strong>{company.gracePeriodValue} {format.pluralize(company.gracePeriodUnit, company.gracePeriodValue)}</strong>
            </div>
            <p>{`Offline donations for ${company.currentYear} must be submitted by end-of-day ${moment.utc(company.gracePeriodEndDateStr).format('MMMM D, YYYY')}.`}</p>
            <button className="btn small secondary blue" onClick={this.onClickGracePeriod}>Edit Grace Period</button>
            
          </div>

          <div className="ca-box-header">
            <h1 className="ca-box-header-title">Employee Access to Nonprofits</h1>
          </div>
          <div className="ca-box-subheader">
            <p>On the Donate tab, which nonprofits should appear in the search results? <strong>Show All Nonprofits</strong> is recommended.</p>
          </div>
          <div className="ca-box-body">
            <SegmentedSelectorInput
              options={[
                {label: 'Only Show Approved', value: 'on'}, 
                {label: 'Show All Nonprofits', value: 'off'}
              ]}
              value={company.searchApprovedNonprofitsOnly ? 'on' : 'off'}
              onChange={this.onChangeSearchApprovedNonprofitsOnly}
              disabled={isSavingSearchApprovedNonprofitsOnly}
              subtext={isSavingSearchApprovedNonprofitsOnly ? <span className="faint">saving...</span> : null}
            />
          </div>
        </div>

        {showModalFees && (
          <ModalFees onClose={this.onCloseFees} />
        )}
        {showTiersEdit && (
          <ModalTiers onClose={this.onCloseTiersModal} />
        )}
        {showGracePeriodEdit && (
          <ModalGracePeriod onClose={this.onCloseGracePeriod} company={company} />
        )}
      </LayoutMatchSettings>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  cattrSet: CadminSlx.cattrSet(state),

  budget: PageSlx.budget(state),
  isSavingAutomaticMatches: PageSlx.isSavingAutomaticMatches(state),
  isSavingSearchApprovedNonprofitsOnly: PageSlx.isSavingSearchApprovedNonprofitsOnly(state),
  isSavingBudget: BudgetsDuck.Slx.isSavingMatch(state),
});

const dispatchToProps = (dispatch) => ({
  saveAutomaticMatches: (automaticMatches) => dispatch(PageAx.saveAutomaticMatches(automaticMatches)),
  saveSearchApprovedNonprofitsOnly: (searchApprovedNonprofitsOnly) => dispatch(PageAx.saveSearchApprovedNonprofitsOnly(searchApprovedNonprofitsOnly)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
  saveBudget: (allocatedAmount) => dispatch(BudgetsDuck.Ax.updateMatch({allocatedAmount})),
});

export default connect(stateToProps, dispatchToProps)(PageCadminSettings);
